'use strict';
define([], function () {

    return {

        init: function () {
            var waystopayElement = document.querySelector('.navfooter-waystopaytext');
            var socialmediaElement = document.querySelector('.navfooter-socialmedialinks__container');
            this.swapImagedatasrc = this.swapImagedatasrc.bind(this);
            this.isImageVisible = this.isImageVisible.bind(this);
            if (waystopayElement) {
                this.isImageVisible(waystopayElement) ? window.addEventListener('load', this.swapImagedatasrc) : window.addEventListener('scroll', this.swapImagedatasrc);
            }
            else {
                if (socialmediaElement) {
                    this.isImageVisible(socialmediaElement) ? window.addEventListener('load', this.swapImagedatasrc) : window.addEventListener('scroll', this.swapImagedatasrc);
                }
            }
        },
        swapImagedatasrc: function () {
            if (document.readyState === 'complete') {
                this.imageList = document.querySelectorAll('#navigation-commonfooter img[data-src]');
                this.imageSrcList = document.querySelectorAll('#navigation-commonfooter img[src]');
                this.imagesrclistLength = this.imageSrcList.length;
                if ((this.imageList)) {
                    for (var iImage = 0; iImage < this.imageList.length; iImage++) {
                        this.imageList[iImage].src = this.imageList[iImage].attributes['data-src'].value;
                        this.imageList[iImage].parentElement.classList.contains('lazyloadfooterimage') ? this.imageList[iImage].parentElement.classList.remove('lazyloadfooterimage') : false;
                    }
                }
            }
        },

        isImageVisible: function (el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    };
});


/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/LazyloadImage.js
 **/